/*
 * premierstreets
 * version 4.5
 * www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, PLATFORM_ID, Inject, ElementRef, ViewChild, AfterViewChecked, ChangeDetectorRef, OnDestroy, Input } from '@angular/core';

import { ListsSandbox } from '../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../core/service/config.service';
import { AccountService } from '../../../core/account/account.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import io from "socket.io-client";
import { ChatService } from '../../../core/chat/chat.service';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var OT;

@Component({
    selector: 'app-social-chat',
    templateUrl: './social-chat.component.html',
    styleUrls: ['./social-chat.component.scss']
})
export class SocialChatComponent implements OnInit, AfterViewChecked, OnDestroy {

    public imagePath: string;
    public slides: Promise<any>;
    @ViewChild('scrollMe') private myScrollContainer: ElementRef;
    @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
    @ViewChild('publisherDiv') publisherDiv: ElementRef;
    @Input('userid') id: number;
    @Input('vendorId') vendorId: number;

    public apiKey = 46980634;
    public sessionId = "";
    public token = "";
    public videoChat = false;
    changeDetectorRef: ChangeDetectorRef;

    constructor(
        public listSandbox: ListsSandbox,
        public configService: ConfigService,
        public accountService: AccountService,
        public formBuilder: FormBuilder,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public chatService: ChatService,
        private ref: ChangeDetectorRef,
        private snackBar: MatSnackBar,
        @Inject(PLATFORM_ID) private platformId: Object) {
        this.changeDetectorRef = ref;
    }

    public messages = [];
    public chats = [];
    public originalChats = [];
    public currentChat: any = {};
    public currentUser: any = null;
    public message = '';
    public socket;
    public session: any = {};
    public publisher: any = {};
    public muted = false;
    ngOnInit() {

        if (isPlatformBrowser(this.platformId)) {
            this.socket = io(this.configService.getScoketUrl(), { path: '/socket.io/' });
            this.socket.on('connect', (data) => {
                console.log(" ***** client join fired ");
                this.socket.emit('join', { userId: this.currentUser.id });
            });

            this.socket.on('getMessage', (data) => {
                const messageData = data.message;
                if (messageData.chatId == this.currentChat.chatId) {
                    messageData.user = messageData.from;
                    if (messageData.user.id !== this.currentUser.id) {
                        this.currentChat.lastMessageTime = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                    }
                    this.socket.emit('markRead', { messageId: messageData.id });
                    const messages = [...this.messages];
                    messages.push(messageData);
                    this.messages = messages;
                    this.scrollToBottom();
                } else {
                    const exisingChat = _.find(this.chats, (chat) => chat.chatId === messageData.chatId);
                    if (exisingChat) {
                        exisingChat.newMessage = true;
                        exisingChat.lastMessageTime = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                        exisingChat.unreadCount = exisingChat.unreadCount + 1;
                        let chats = [...this.chats];
                        chats = chats.filter(item => item.chatId !== messageData.chatId);
                        chats.unshift(exisingChat);
                        this.chats = chats;
                    } else {
                        let newChat = messageData.from;
                        newChat.unreadCount = 1;
                        newChat.newMessage = true;
                        newChat.chatId = messageData.chatId;
                        newChat.lastMessageTime = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                        let chats = [...this.chats];
                        chats.unshift(newChat);
                        this.chats = chats;
                    }
                }
            });

            this.socket.on('initiateCall', (data) => {
                this.token = data.token;
                this.sessionId = data.sessionId;

                this.initializeSession();
            });

            this.socket.on('busy', (data) => {
                this.snackBar.open("User is on another call", '×', {
                    panelClass: 'success',
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 3000
                });
            });

            this.socket.on('call', (data) => {
                this.sessionId = data.sessionId;
                this.videoChat = true;
                this.changeDetectorRef.detectChanges();
                this.socket.emit('getToken', { sessionId: this.sessionId });
            })

        }


        this.imagePath = this.configService.getImageUrl();
        if (isPlatformBrowser(this.platformId)) {
            this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
        }


        if (this.id) {
            this.getChat(this.id).then(() => {
                this.getChats();
            })
        } else {
            this.getChats();
        }

    }

    public handleError(error) {
        if (error) {
            alert(error.message);
        }
    }

    public endCall() {
        this.videoChat = false;
        this.session.disconnect();
    }

    public mute() {
        this.publisher.publishAudio(this.muted);
        this.muted = !this.muted;
    }

    public initializeSession() {
        this.muted = false;
        const session = OT.initSession(this.apiKey, this.sessionId);
        this.session = session;
        // Subscribe to a newly created stream

        // Create a publisher
        const publisher = OT.initPublisher(this.publisherDiv.nativeElement, {
            insertMode: 'append',
            width: '100%',
            height: '100%'
        }, this.handleError);

        this.publisher = publisher;

        console.log(" ******** this.token **** ", this.token);

        // Connect to the session
        session.connect(this.token, (error) => {
            // If the connection is successful, publish to the session
            if (error) {
                this.handleError(error);
            } else {
                session.publish(publisher, this.handleError);
            }
        });

        session.on('streamCreated', (event) => {
            session.subscribe(event.stream, this.subscriberDiv.nativeElement, {
                insertMode: 'append',
                width: '100%',
                height: '100%'
            }, this.handleError);
            this.changeDetectorRef.detectChanges();
        });

        session.on('connectionDestroyed', (event) => {
            this.videoChat = false;
            publisher.destroy();
            this.socket.emit('callDisconnected');
            this.changeDetectorRef.detectChanges();
        });

        session.on('streamDestroyed', (event) => {
            this.videoChat = false;
            this.socket.emit('callDisconnected');
            this.changeDetectorRef.detectChanges();
        });

    }

    public getChats() {
        return this.chatService.listChat({}).toPromise().then((response) => {
            this.chats = response.data.map(item => {
                const newItem = item.fromId == this.currentUser.id ? item.to : item.from;
                newItem.chatId = item.id;
                newItem.unreadCount = item.unreadCount;
                console.log(" ******** newItem ", item.unreadCount);
                newItem.lastMessage = item.lastMessage,
                    newItem.lastMessageTime = item.lastMessageTime
                return newItem
            });
            this.originalChats = this.chats;
        });
    }

    relativeTime(date) {
        if (moment().diff(moment.tz(date, 'YYYY-MM-DD HH:mm:ss', 'UTC'), 'minutes') < 2) {
            return 'Online';
        } else {
            return 'Last active ' + moment.tz(date, 'YYYY-MM-DD HH:mm:ss', 'UTC').fromNow();
        }
    }

    public setCurrentChat(chat) {
        chat.newMessage = false;
        chat.unreadCount = 0;
        this.currentChat = chat;
        this.socket.emit('markAllRead', { chatId: chat.chatId });
        this.getMessages(chat.chatId);
    }

    public getMessages(id: number) {
        this.messages = [];
        this.chatService.getMessages({ chat_id: id }).toPromise().then((response) => {
            let messages = response.data.map(item => {
                item.user = item.from;
                return item;
            });

            messages = _.groupBy(messages, (item) => {
                return moment(item.createdDate).format('YYYY-MM-DD');
            })

            let modifiedMessages = [];

            for (let date in messages) {
                modifiedMessages.push({ type: 1, date: date, user: {} });
                modifiedMessages = modifiedMessages.concat(messages[date]);
            }

            this.messages = modifiedMessages;
        });
    }

    public getChat(userId: number) {
        return this.chatService.getChat({ user_id: userId }).toPromise().then(response => {
            const currentChat = this.currentUser.id == response.data.fromId ? response.data.to : response.data.from;
            currentChat.chatId = response.data.id;
            currentChat.unreadCount = 0;
            this.currentChat = currentChat;
            this.socket.emit('markAllRead', { chatId: response.data.id });
            this.getMessages(response.data.id);
        });
    }

    public startVideoChat() {
        this.videoChat = true;
        this.socket.emit('generateSession', { userId: this.currentChat.id });
    }

    public filter(event) {
        this.chats = this.originalChats.filter(item => { return (item.firstName.indexOf(event.target.value) !== -1) })
    }

    public sendMessage(e) {

        e.preventDefault();

        if (this.message && (this.message !== '\n')) {

            if (!this.currentChat.chatStatus && this.vendorId) {
                this.snackBar.open('Vendor is offline, he will respond once he is back online.', '×', {
                    panelClass: 'error',
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 3000
                });
            }

            this.currentChat.lastMessage = this.message;
            //  this.currentChat.lastMessageTime = moment().format('YYYY-MM-DD');
            this.socket.emit('sendMessage', { message: this.message, vendorId: this.vendorId, chatId: this.currentChat.chatId, userId: this.currentChat.id, user: { id: this.currentUser.id, firstName: this.currentUser.firstName, lastName: this.currentUser.lastName } });
            this.message = '';
        } else {
            this.message = '';
        }
    }


    ngAfterViewChecked() {
        this.scrollToBottom();
    }

    scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch (err) { }
    }

    ngOnDestroy() {
        if (this.socket) {
            this.socket.disconnect();
        }

    }
}
